// extracted by mini-css-extract-plugin
export default {"customScrollbar":"HomeTemplate_customScrollbar__36o7b"};